<template>
	<div class="downPage">
		<img src="@/assets/banner.png" alt="" />
		<Footer />
	</div>
</template>
<script>
import Footer from './footer.vue'
export default {
	// 下载
	name: 'Down',
	components: { Footer },
}
</script>
<style lang="scss" scoped>
.downPage {
	width: 100%;
	img {
		width: 100%;
		vertical-align: top;
	}
}
</style>
